/*globals incomingData, strip, chartTypes */

// used for A3 and control tower pop up graphs
angular.module('embeddedMetricCharts', ['ui.bootstrap', 'angularutilities', 'pascalprecht.translate', 'app.core'])
	.value('hostUrl', '/api/')

	.config(['$httpProvider',
		function ($httpProvider) {
			if (!$httpProvider.defaults.headers.get) {
				$httpProvider.defaults.headers.get = {};
			}
			$httpProvider.defaults.headers.get['If-Modified-Since'] = '0';
		}])

	.service('metricsData', function ($http, hostUrl) {
		var urlPfx = '2/factndx/';
		return {
			getChartData: getChartData,
			getMetricList: getMetricList
		};

		function getChartData(metric, startDate, endDate, valueStreamNdx, row, col, vsList, fromControlTower, factory, currency) {
			if (!factory) {
				factory = globalConfig.factory.id;
			}
			var url = urlPfx + factory + '/Metric/' + metric.ndx + '/MetricResults';
			var qryParams = {};

			if (typeof (startDate) === 'string' && startDate.length > 0) {
				qryParams.startDate = startDate.trim();
			} else if (typeof (startDate) === 'number' && startDate > 0) {
				qryParams.startTimestamp = startDate;
			}

			if (typeof (endDate) === 'string' && endDate.length > 0) {
				qryParams.endDate = endDate.trim();
			} else if (typeof (endDate) === 'number' && endDate > 0) {
				qryParams.endTimestamp = endDate;
			}
			if (currency) {
				qryParams.currency = currency;
			}

			if (vsList && vsList.length > 0) {
				qryParams.vstreams = vsList.toString();
			} else if (!fromControlTower &&
				valueStreamNdx &&
				valueStreamNdx >= 0 && valueStreamNdx.toString() &&
				valueStreamNdx.toString().length > 0) {
				qryParams.vstreams = valueStreamNdx;
			}

			url += '?' + jQuery.param(qryParams);

			return $http.get(hostUrl + url)
				.then(getChartDataComplete)
				.catch(getChartDataFailed);

			function getChartDataComplete(response) {
				response.row = row;
				response.col = col;
				return response;
			}

			function getChartDataFailed(error) {
				return undefined;
			}
		}

		function getMetricList(param, factory, row, col, parentMetricNdx) {
			if (!factory) {
				factory = globalConfig.factory.id;
			}
			var url = urlPfx + factory + '/Metrics';
			var qryParams = {};
			if (param.initiativeNdx) {
				qryParams.initiativeNdx = param.initiativeNdx;
			} else if (param.metricNdx) {
				qryParams.metricNdx = param.metricNdx;
			}
			url += '?' + jQuery.param(qryParams);
			return $http.get(hostUrl + url)
				.then(getMetricListComplete)
				.catch(getMetricListFailed);

			function getMetricListComplete(response) {
				if (param.metricNdx && response && response.data && response.data[0]) {
					response.data[0].vsndx = param.vsNdx;
				}
				if (response && response.data && response.data[0]) {
					response.data[0].row = row;
					response.data[0].col = col;
					response.data[0].parentMetricNdx = parentMetricNdx;
				} else {
					response.data = [];
					response.data.push({
						'row': row,
						'col': col,
						'parentMetricNdx': parentMetricNdx
					});
				}
				return response.data;
			}

			function getMetricListFailed(error) {
				return undefined;
			}
		}
	})

	.controller('metricsController', function ($scope, $timeout, $q, metricsData) {
		var fromControlTower = false;
		$scope.metrics = [];
		$scope.chartData = [];
		$scope.metricsService = metricsData;
		$scope.hasMetrics = false;
		$scope.getChartData = function (ndx, vsndx) {
			var parsedNdx;
			var parsedVsndx;
			if (ndx) {
				parsedNdx = parseInt(ndx);
			}
			if (vsndx) {
				parsedVsndx = parseInt(vsndx);
			}
			for (var i = 0; i <
				$scope.chartData.length; i++) {
				var row = $scope.chartData[i];
				for (var j = 0; j < row.length; j++) {
					if (row[j].metricConfig &&
							row[j].metricConfig.ndx == parsedNdx &&
							row[j].metricConfig.vsndx == parsedVsndx) {
						return row[j];
					}
				}
			}
			return {};
		};

		function getMetrics() {
			var param = {};
			if (incomingData.initiativeNdx) {
				param.initiativeNdx = incomingData.initiativeNdx;
			} else if (incomingData.metricNdx) {
				param.metricNdx = incomingData.metricNdx;
				if (incomingData.vsNdx) {
					param.vsNdx = incomingData.vsNdx;
				}
				fromControlTower = true;
			}
			$scope.metricsService.getMetricList(param, incomingData.factory).then(function (data) {
				$scope.metrics = data;
				if ($scope.metrics && $scope.metrics.length > 0 && $scope.metrics[0] && $scope.metrics[0].name) {
					$scope.hasMetrics = true;
					generatePlaceHolders();
					getCharts();
				} else {
					$scope.hasMetrics = false;
				}
			});
		}

		function generatePlaceHolders() {
			var index = 0;
			var row = 0;
			var total = $scope.metrics.length;
			angular.forEach($scope.metrics, function (met) {
				if (!met.vsName) {
					met.vsName = 'Plant Wide';
				}
				var temp = $scope.chartData[row];
				if (temp && temp.length === 2) {
					row++;
					temp = [];
					$scope.chartData.push(temp);
				}
				if (!temp) {
					temp = [];
					$scope.chartData[row] = temp;
				}
				var obj = {
					'metricConfig': met,
					'data': {},
					'class': getColClass(index, total),
					'empty': true
				};
				temp.push(obj);
				index++;
			});
		}

		function getCharts() {
			var vsList = [];
			if (fromControlTower) {
				vsList = incomingData.vsList;
			}
			var metricData = {};
			for (var i = 0; i < $scope.chartData.length; i++) {
				var row = $scope.chartData[i];
				for (var j = 0; j < row.length; j++) {
					var met = row[j];
					if (met.metricConfig && !(met.metricConfig.componentAxes && met.metricConfig.componentAxes.length)) {
						metricsData.getChartData(met.metricConfig, incomingData.beginDate, incomingData.endDate,
							met.metricConfig.vsndx, i, j, vsList, fromControlTower, incomingData.factory,
							incomingData.currency)
							.then(function (response) {
								if (response) {
									var metMatch = $scope.chartData[response.row][response.col];
									if (incomingData.initiativeNdx || incomingData.currency) {
										metMatch.metricConfig.projectFactoryNdx = incomingData.factory;
										metMatch.metricConfig.currency = incomingData.currency;
									}
									metMatch.data = response.data;
									if (metMatch.data && (metMatch.data.results || metMatch.data.targets)) {
										metMatch.empty = false;
										var vsNdx = metMatch.metricConfig.vsndx;
										if (vsNdx === undefined) {
											vsNdx = '';
										}
										$timeout(function () {
											$scope.$broadcast('event:metricCtrl' + metMatch.metricConfig.ndx + '-' + vsNdx + ':getChart', null);
										}, 0);
									}
								}
							});
					} else {
						// GET component metrics
						metricData[met.metricConfig.ndx] = {};
						metricData[met.metricConfig.ndx].componentMetricNdxs = met.metricConfig.componentMetrics.split(',');
						metricData[met.metricConfig.ndx].componentMetricAxes = met.metricConfig.componentAxes.split(',');
						metricData[met.metricConfig.ndx].componentMetricVisibleTargets = met.metricConfig.componentShowTarget.split(',');
						metricData[met.metricConfig.ndx].componentMetrics = [];
						metricData[met.metricConfig.ndx].crossSiteName = met.metricConfig.crossSiteName;
						var metricPromiseList = [];
						for (var k = 0; k < metricData[met.metricConfig.ndx].componentMetricNdxs.length; k++) {
							var param = {};
							param.metricNdx = metricData[met.metricConfig.ndx].componentMetricNdxs[k];
							if (incomingData.vsNdx) {
								param.vsNdx = incomingData.vsNdx;
							}
							var promise = $scope.metricsService.getMetricList(param, incomingData.factory, i, j, met.metricConfig.ndx);
							metricPromiseList.push(promise);
						}
						$q.all(metricPromiseList).then(function (result) {
							var metOneArr = result[0];
							var metTwoArr = result[1];
							var parentMetricNdx = metOneArr[0].parentMetricNdx;
							metricData[parentMetricNdx].componentMetrics.push(metOneArr[0]);
							metricData[parentMetricNdx].componentMetrics.push(metTwoArr[0]);
							metricPromiseList = [];
							var promiseOne = metricsData.getChartData(metricData[parentMetricNdx].componentMetrics[0],
								incomingData.beginDate, incomingData.endDate,
								metricData[parentMetricNdx].componentMetrics[0].vsndx,
								metricData[parentMetricNdx].componentMetrics[0].row,
								metricData[parentMetricNdx].componentMetrics[0].col,
								vsList, fromControlTower, incomingData.factory, incomingData.currency);
							var promiseTwo = metricsData.getChartData(metricData[parentMetricNdx].componentMetrics[1],
								incomingData.beginDate, incomingData.endDate,
								metricData[parentMetricNdx].componentMetrics[1].vsndx,
								metricData[parentMetricNdx].componentMetrics[1].row,
								metricData[parentMetricNdx].componentMetrics[1].col,
								vsList, fromControlTower, incomingData.factory, incomingData.currency);
							$q.all([promiseOne, promiseTwo]).then(function (resultInner) {
								var metMatch = $scope.chartData[resultInner[0].row][resultInner[0].col];
								metMatch.data = {};
								metMatch.data.results = [];
								metMatch.data.targets = [];
								var metName = metMatch.metricConfig.name;
								var vsName = metMatch.metricConfig.vsName;
								var broadCastNdx = metMatch.metricConfig.ndx;
								var vsNdx = metMatch.metricConfig.vsndx;
								if (vsNdx === undefined) {
									vsNdx = '';
								}
								metMatch.metricConfig = {};
								var metOneConfig = metricData[broadCastNdx].componentMetricAxes[0] === 'y' ?
									metricData[broadCastNdx].componentMetrics[0] : metricData[broadCastNdx].componentMetrics[1];
								var metTwoConfig = metricData[broadCastNdx].componentMetricAxes[0] === 'y' ?
									metricData[broadCastNdx].componentMetrics[1] : metricData[broadCastNdx].componentMetrics[0];
								var metricOne = metricData[broadCastNdx].componentMetricAxes[0] === 'y' ?
									resultInner[0].data : resultInner[1].data;
								var metricTwo = metricData[broadCastNdx].componentMetricAxes[0] === 'y' ?
									resultInner[1].data : resultInner[0].data;
								var targetAxis = '';
								if (metricData[broadCastNdx].componentMetricVisibleTargets[0] == 1) {
									targetAxis = metricData[broadCastNdx].componentMetricAxes[0];
								}
								if (metricData[broadCastNdx].componentMetricVisibleTargets[1] == 1) {
									targetAxis = metricData[broadCastNdx].componentMetricAxes[1];
								}
								metMatch.data.results = metricOne.results;
								metMatch.data.targets = targetAxis === 'y2' ? metricTwo.targets : metricOne.targets;
								// Combine results
								for (var l = 0; l < metricTwo.results.length; l++) {
									var ind = findMatchingXPoint(metricOne.results, metricTwo.results[l].date);
									if (ind === -1 || metTwoConfig.isCategorized) {
										var tmp = {};
										tmp.valueTwo = metricTwo.results[l].value;
										tmp.date = metricTwo.results[l].date;
										if (metricTwo.results[l].category) {
											tmp.categoryTwo = metricTwo.results[l].category;
										}
										metMatch.data.results.push(tmp);
										if (!metTwoConfig.isCategorized) {
											tmp.category = null;
										}
									} else {
										var obj = metMatch.data.results[ind];
										obj.valueTwo = metricTwo.results[l].value;
										obj.categoryTwo = metricTwo.results[l].category;
									}
								}

								// Build new metric config
								var combMetConfig = {};
								combMetConfig.displayResolutionType = 'Monthly';
								if (metOneConfig.displayResolutionType === 'Weekly' || metTwoConfig.displayResolutionType === 'Weekly') {
									combMetConfig.displayResolutionType = 'Weekly';
								}
								if (metOneConfig.displayResolutionType === 'Daily' || metTwoConfig.displayResolutionType === 'Daily') {
									combMetConfig.displayResolutionType = 'Daily';
								}
								combMetConfig.isCategorized = metOneConfig.isCategorized;
								combMetConfig.isCategorizedTwo = metTwoConfig.isCategorized;
								combMetConfig.chartType = metOneConfig.chartType;
								combMetConfig.chartTypeTwo = metTwoConfig.chartType;
								combMetConfig.goalType = metOneConfig.goalType;
								combMetConfig.goalTypeTwo = metTwoConfig.goalType;
								combMetConfig.yAxisLabel = metOneConfig.yAxisLabel;
								combMetConfig.yAxisLabelTwo = metTwoConfig.yAxisLabel;
								combMetConfig.displayType = metOneConfig.displayType;
								combMetConfig.displayTypeTwo = metTwoConfig.displayType;
								combMetConfig.yAxisMinFixedValue = metOneConfig.yAxisMinFixedValue;
								combMetConfig.yAxisMinFixedValueTwo = metTwoConfig.yAxisMinFixedValue;
								combMetConfig.yAxisMaxFixedValue = metOneConfig.yAxisMaxFixedValue;
								combMetConfig.yAxisMaxFixedValueTwo = metTwoConfig.yAxisMaxFixedValue;
								combMetConfig.yAxisMinCalcType = metOneConfig.yAxisMinCalcType;
								combMetConfig.yAxisMinCalcTypeTwo = metTwoConfig.yAxisMinCalcType;
								combMetConfig.yAxisMaxCalcType = metOneConfig.yAxisMaxCalcType;
								combMetConfig.yAxisMaxCalcTypeTwo = metTwoConfig.yAxisMaxCalcType;
								combMetConfig.ndx = broadCastNdx;
								combMetConfig.vsndx = vsNdx;
								combMetConfig.comboChart = true;
								combMetConfig.axis = 'y';
								combMetConfig.axisTwo = 'y2';
								combMetConfig.targetsVisible = targetAxis;
								combMetConfig.crossSiteName = metricData[broadCastNdx].crossSiteName;
								for (var l = 0; l < metMatch.data.results.length; l++) {
									if (chartTypes[combMetConfig.chartType] === 'bar') {
										metMatch.data.results[l].hasBar = metMatch.data.results[l].value || metMatch.data.results[l].value == 0;
									}
									if (chartTypes[combMetConfig.chartTypeTwo] === 'bar') {
										metMatch.data.results[l].hasBar = metMatch.data.results[l].valueTwo || metMatch.data.results[l].valueTwo == 0;
									} else {
										metMatch.data.results[l].hasBar = metMatch.data.results[l].hasBar || false;
									}
								}
								metMatch.metricConfig = combMetConfig;
								metMatch.metricConfig.name = metName;
								metMatch.metricConfig.vsName = vsName;
								metMatch.empty = metMatch.data.results.length === 0 && metMatch.data.targets.length === 0;
								if (incomingData.initiativeNdx) {
									metMatch.metricConfig.projectFactoryNdx = incomingData.factory;
								}
								$scope.$broadcast('event:metricCtrl' + broadCastNdx + '-' + vsNdx + ':getChart', null);
							});
						});
					}
				}
			}
		}

		function findMatchingXPoint(list, date) {
			for (var i = 0; i < list.length; i++) {
				if (list[i].date === date) {
					return i;
				}
			}
			return -1;
		}

		function getColClass(index, total) {
			if (jQuery('.modal-footer .embeddedCharts').length > 0) {
				return 'col-sm-12';
			}
			return 'col-sm-6';
		}

		function init() {
			getMetrics();
			//getCharts();
		}
		init();
	});
